"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateFakeOfferRule = void 0;
const faker_1 = __importDefault(require("@faker-js/faker"));
const originator_client_1 = require("@evenfinancial/originator-client");
const api_models_1 = require("@portal/api-models");
const create_unique_id_1 = require("./utils/create-unique-id");
const loanPurposeValues = Object.values(originator_client_1.LoanPurpose);
const militaryStatusValues = Object.values(api_models_1.MilitaryStatus);
const employmentStatusValues = Object.values(originator_client_1.EmploymentStatus);
faker_1.default.seed(718);
const generateUniqueRootId = (0, create_unique_id_1.createUniqueIdGenerator)();
const generateUniqueSupplySubAccountId = (0, create_unique_id_1.createUniqueIdGenerator)();
const generateFakeOfferRule = () => ({
    createdAt: faker_1.default.date.recent(),
    createdByUuid: faker_1.default.datatype.uuid(),
    demandSubAccountId: faker_1.default.datatype.number({ min: 1 }),
    employmentStatus: faker_1.default.helpers.arrayElements(employmentStatusValues, faker_1.default.datatype.number({ max: 5, min: 1 })),
    id: faker_1.default.datatype.number({ min: 1 }),
    loanPurposeKeys: faker_1.default.helpers.arrayElements(loanPurposeValues, faker_1.default.datatype.number({ max: 5, min: 1 })),
    militaryStatuses: faker_1.default.helpers.arrayElements(militaryStatusValues, faker_1.default.datatype.number({ max: 2, min: 1 })),
    rootId: generateUniqueRootId(),
    staticOfferId: faker_1.default.datatype.number({ min: 1 }),
    supplySubAccountIds: [
        generateUniqueSupplySubAccountId(),
        generateUniqueSupplySubAccountId(),
    ],
});
exports.generateFakeOfferRule = generateFakeOfferRule;
